import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function Button({
  children,
  className = '',
  href,
  onClick,
  ...props
}: ButtonProps) {
  const baseClasses = `inline-flex items-center justify-center px-8 py-4 text-base md:text-lg font-bold text-carbon bg-gold hover:bg-[#d9a404] transition-all duration-200 rounded-sm text-center hover:scale-105 hover:brightness-110 ${className}`;
  if (href) {
    return <a href={href} className={baseClasses} target="_blank" rel="noopener noreferrer" data-id="element-252">
        {children}
      </a>;
  }
  return <button className={baseClasses} onClick={onClick} {...props} data-id="element-253">
      {children}
    </button>;
}